import $ from 'jquery'
import Screen from './screen'
import { isScroll } from '../_variables'

export default class RoutineScroll {
  init() {
    $(function () {
      const screen = new Screen()

      $('.c-box-routine').on('touchstart', function () {
        if (!$(this).hasClass(isScroll)) {
          $(this).addClass(isScroll)
        }
      })

    })
  }
}
